import { IRgrCertificateProps, AgentType } from '.';
import * as styles from './styles.css';
import { stopPropagation } from '../../utils/stopPropagation';

export const RgrTooltip = ({ type }: IRgrCertificateProps) => {
  const title = `${type === AgentType.Realtor ? 'Агент' : 'Агентство'} входит в РГР`;
  const subtitle = `Стандарты качества услуг ${
    type === AgentType.Realtor ? 'агента' : 'компании'
  } сертифицированы, деятельность застрахована`;

  return (
    <div className={styles['container']} onClick={stopPropagation}>
      <h4 className={styles['title']}>{title}</h4>
      <a
        className={styles['link']}
        href="https://hc.cian.ru/hc/ru/articles/4409480755348"
        target="_blank"
        rel="noreferrer"
      >
        Подробнее
      </a>
      <div className={styles['content']}>{subtitle}</div>
    </div>
  );
};
